import React from 'react';
import * as Yup from 'yup';
import type { FormikConfig } from 'formik';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { normalizeFormError } from 'app/utils';

import { TranslationKeys } from '../../translations';

import { appService } from '../../Domain/App/Services/AppServices';

import { PublicLayout } from '../../layouts';

import { ForgotPasswordViewForm } from './components';

import type { ForgotPassViewFormValues } from './ForgotPasswordView.types';

export const ForgotPasswordView = () => {
  const navigate = useNavigate();

  const formikInitialValues = React.useMemo<ForgotPassViewFormValues>(() => {
    return {
      email: '',
    };
  }, []);

  const formikValidationSchema = React.useMemo(() => {
    return Yup.object().shape({
      email: Yup.string().email().required(),
    });
  }, []);

  const formikOnSubmit = React.useCallback<FormikConfig<ForgotPassViewFormValues>['onSubmit']>(
    async (values, form) => {
      try {
        const data = await appService.forgotPasswordRequest(values.email);

        if (data.data.code === 401) {
          form.setStatus(data.data.message);
        } else {
          navigate('/sign-in');
        }
      } catch (error: any) {
        const errors = normalizeFormError(error, form);
        if (!errors.violations) {
          throw errors.error;
        }
      }
    },
    [navigate],
  );

  return (
    <PublicLayout titleId={TranslationKeys.forgotPassword_title}>
      <Formik<ForgotPassViewFormValues>
        initialValues={formikInitialValues}
        validationSchema={formikValidationSchema}
        onSubmit={formikOnSubmit}
      >
        <ForgotPasswordViewForm />
      </Formik>
    </PublicLayout>
  );
};
